import type { GameComponentProps } from '../core/types';
import { FixtureGame } from '../fixture/FixtureGame';
import { ChromalGame } from './ChromalGame';

export function ChromalEntry(props: GameComponentProps) {
  if (props.puzzle.generatorVersion < 2) return <FixtureGame {...props} />;
  return <ChromalGame {...props} />;
}
